// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"123":"8042442e","189":"10288943","357":"6ed213cc","508":"acb3b6d7","762":"e199a5a1","794":"427854f3","854":"da4e12d2","865":"93d9c480","867":"b1a63d00","915":"6fb4a13e","933":"174e415b"}[chunkId] + ".js";
};